import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import { TaskTemplate } from '@/types';
    import { usePermissions } from '@/composables/usePermissions';
    import EditTaskTemplate from './EditTaskTemplate.vue';
    import Delete from '@/components/Delete.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';

    interface Props {
        taskTemplate: TaskTemplate;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'TaskTemplateTableActions',
  props: {
    taskTemplate: {}
  },
  setup(__props: any) {

    

    const { hasPermission } = usePermissions();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.taskTemplate }, {
    default: _withCtx(() => [
      (_unref(hasPermission)(_unref(Permission).TASK_TEMPLATES_UPDATE))
        ? (_openBlock(), _createBlock(EditTaskTemplate, {
            key: 0,
            "task-template": _ctx.taskTemplate
          }, null, 8, ["task-template"]))
        : _createCommentVNode("", true),
      (_unref(hasPermission)(_unref(Permission).TASK_TEMPLATES_DELETE))
        ? (_openBlock(), _createBlock(Delete, {
            key: 1,
            route: _ctx.route('v2.task-templates.destroy', _ctx.taskTemplate.id),
            "query-key": [_unref(QueryKey).TASK_TEMPLATES],
            header: "task-templates.delete.title",
            description: "task-templates.delete.content"
          }, null, 8, ["route", "query-key"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})